var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoveBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "love_b",
    transform: "translate(-4393.675 -2310.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4393.675 2310.85)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M4411.82,2338.842l8.023-6.489a5.955,5.955,0,0,0,1.952-2.8c1.473-4.619-2.717-9.561-7.675-7.621a2.3,2.3,0,0,1-4.6,0c-4.958-1.94-9.148,3-7.674,7.621a5.944,5.944,0,0,0,1.952,2.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveBlack);
export default __webpack_public_path__ + "static/media/love_black.e885e973bc49301d4aa80be737f242f8.svg";
export { ForwardRef as ReactComponent };